import { call, put, takeLatest } from 'redux-saga/effects';
import { 
  addFcmTokenRequest, addFcmTokenSuccess, addFcmTokenFailure,
  getAppLoadDataRequest, getAppLoadDataSuccess, getAppLoadDataFailure,
  getEmojiCategoryRequest, getEmojiCategorySuccess, getEmojiCategoryFailure,
  getMusicsRequest, getMusicsSuccess, getMusicsFailure,
  getFontsRequest, getFontsSuccess, getFontsFailure,
  generateVideoRequest, generateVideoSuccess, generateVideoFailure,
  getTemplateCategoriesRequest, getTemplateCategoriesSuccess, getTemplateCategoriesFailure,
  getTemplateByCategoryRequest, getTemplateByCategorySuccess, getTemplateByCategoryFailure,
  getTemplateByIdRequest, getTemplateByIdSuccess, getTemplateByIdFailure,
  updateCreatedInvitationInfoRequest, updateCreatedInvitationInfoSuccess, updateCreatedInvitationInfoFailure,
  getCreatedInvitationsRequest, getCreatedInvitationsSuccess, getCreatedInvitationsFailure,
} from '../slice/appSlice';
import { setSlides, setTemplateConfig } from '../slice/globalAppSlice';
import AppService from '../../services/AppService';
import { normalizeSlides } from '../../utils/appHelper';

function* handleAddFcmToken(action) {
  try {
    const response = yield call(AppService.addFcmToken, action.payload);
    if (!response.success) {
      yield put(addFcmTokenFailure(response));
    } else {
      yield put(addFcmTokenSuccess(response.data));
    }
  } catch (error) {
     console.log(error);
    yield put(addFcmTokenFailure(error));
  }
}

function* handleGetAppLoadData(action) {
  try {
    const response = yield call(AppService.getAppLoadData, action.payload);
    console.log('--handleGetAppLoadData--', response);
    if (!response.success) {
      //yield put(getAppLoadDataFailure(response));
    } else {
      yield put(getAppLoadDataSuccess(response.data));
      //yield call([mmkvStore, mmkvStore.saveItem], 'appLoadData', response.data);
    }
  } catch (error) {
    console.log(error);
    //yield put(getAppLoadDataFailure(error));
  }
}

function* handleGetEmojiCategory(action) {
  try {
    const response = yield call(AppService.getEmojiCategories, action.payload);
    console.log('--handleDashboardData--',response);
    if (!response.success) {
      yield put(getEmojiCategoryFailure(response));
      //ToastHelper.error({type: 'error', text1: '',  text2: response?.message || ''});
    } else {
      yield put(getEmojiCategorySuccess(response.data));
    }
  } catch (error) {
    console.log(error);
    yield put(getEmojiCategoryFailure(error));
  }
}

function* handleGetMusics(action: any) {
  try {
    const response = yield call(AppService.getMusics, action.payload);
    if (!response.success) {
      yield put(getMusicsFailure(response));
    } else {
      yield put(getMusicsSuccess(response.data));
    }
  } catch (error) {
    yield put(getMusicsFailure(error));
  }
}

function* handleGetFonts(action) {
  try {
    const response = yield call(AppService.getFonts, action.payload);
    console.log('--handleDashboardData--',response);
    if (!response.success) {
      yield put(getFontsFailure(response));
      //ToastHelper.error({type: 'error', text1: '',  text2: response?.message || ''});
    } else {
      yield put(getFontsSuccess(response.data));
    }
  } catch (error) {
    console.log(error);
    yield put(getFontsFailure(error));
  }
}

function* handleGenerateVideo(action) {
  try {
    const response = yield call(AppService.generateVideo, action.payload);
    console.log('--handleGenerateVideo--',response, action.payload);
    if (!response.success) {
      yield put(generateVideoFailure(response));
      //ToastHelper.error({type: 'error', text1: '',  text2: response?.message || ''});
    } else {
      yield put(generateVideoSuccess(response.data));
    }
  } catch (error) {
    console.log(error);
    yield put(generateVideoFailure(error));
  }
}

function* handleGetTemplateCategories(action) {
  try {
    const response = yield call(AppService.getTemplateCategories, action.payload);
    console.log('--getTemplateCategories--',response);
    if (!response.success) {
      yield put(getTemplateCategoriesFailure(response));
      //ToastHelper.error({type: 'error', text1: '',  text2: response?.message || ''});
    } else {
      yield put(getTemplateCategoriesSuccess(response.data));
    }
  } catch (error) {
    console.log(error);
    yield put(getTemplateCategoriesFailure(error));
  }
}

function* handleGetTemplateByCategory(action) {
  try {
    const response = yield call(AppService.getTemplateByCategory, action.payload);
    console.log('--getTemplateByCategory--',response);
    if (!response.success) {
      yield put(getTemplateByCategoryFailure(response));
      //ToastHelper.error({type: 'error', text1: '',  text2: response?.message || ''});
    } else {
      yield put(getTemplateByCategorySuccess(response.data));
    }
  } catch (error) {
    console.log(error);
    yield put(getTemplateByCategoryFailure(error));
  }
}

function* handleGetTemplateById(action) {
  try {
    const response = yield call(AppService.getTemplateById, action.payload);
    if (!response.success) {
      yield put(getTemplateByIdFailure(response));
    } else {
      const templateConfig = response.data?.template_config;
      
      // 1. Save Raw Template Data
      yield put(getTemplateByIdSuccess(response.data));

      // 2. Normalize and Push to Editor State (Global Slice)
      if (templateConfig) {
        yield put(setTemplateConfig(templateConfig)); // Store config
        const normalized = normalizeSlides(templateConfig.slides || []);
        yield put(setSlides(normalized)); // Store editable slides
      }
    }
  } catch (error) {
    yield put(getTemplateByIdFailure(error));
  }
}

function* handleUpdateCreatedInvitationInfo(action) {
  try {
    const response = yield call(AppService.updateCreatedInvitationInfo, action.payload);
    if (!response.success) {
      yield put(updateCreatedInvitationInfoFailure(response));
    } else {
      yield put(updateCreatedInvitationInfoSuccess(response.data));
    }
  } catch (error) {
    yield put(updateCreatedInvitationInfoFailure(error));
  }
}

function* handleGetCreatedInvitations(action) {
  try {
    const response = yield call(AppService.getCreatedInvitations, action.payload);
    if (!response.success) {
      yield put(getCreatedInvitationsFailure(response));
    } else {
      yield put(getCreatedInvitationsSuccess(response.data));
    }
  } catch (error) {
    yield put(getCreatedInvitationsFailure(error));
  }
}

export default function* appSaga() {
  yield takeLatest(addFcmTokenRequest.type, handleAddFcmToken);
  yield takeLatest(getAppLoadDataRequest.type, handleGetAppLoadData);
  yield takeLatest(getEmojiCategoryRequest.type, handleGetEmojiCategory);
  yield takeLatest(getMusicsRequest.type, handleGetMusics);
  yield takeLatest(getFontsRequest.type, handleGetFonts);
  yield takeLatest(generateVideoRequest.type, handleGenerateVideo);
  yield takeLatest(getTemplateCategoriesRequest.type, handleGetTemplateCategories);
  yield takeLatest(getTemplateByCategoryRequest.type, handleGetTemplateByCategory);
  yield takeLatest(getTemplateByIdRequest.type, handleGetTemplateById);
  yield takeLatest(updateCreatedInvitationInfoRequest.type, handleUpdateCreatedInvitationInfo);
  yield takeLatest(getCreatedInvitationsRequest.type, handleGetCreatedInvitations);
}
